import { render, staticRenderFns } from "./Ibox.vue?vue&type=template&id=2d387a8b&scoped=true"
import script from "./Ibox.vue?vue&type=script&lang=js"
export * from "./Ibox.vue?vue&type=script&lang=js"
import style0 from "./Ibox.vue?vue&type=style&index=0&id=2d387a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d387a8b",
  null
  
)

export default component.exports